<template>
  <div class="modal-wrap modal-wrap--35">
    <div class="modal-header">
      <p class="mb-15 bold">Annullera/Radera bud</p>
    </div>

    <div class="modal-content">
        <p class="mb-15">Vill du annullera eller radera budgivare {{ currentBid.bidderId }}:s bud på <br><span class="bold">{{ $root.formatPrice(currentBid.amount) }} kr?</span></p>
        <p>Ett annullerat bud markeras som återtaget och visas som överstruket i budlistan, medan ett raderat bud tas bort permanent.</p>

      <div class="flex justify-between mb-30 mt-20">
        <div><label><input type="radio" class="mr-5" value="1" v-model="deleteOrCancelBid">Radera</label></div>
        <div><label><input type="radio" class="mr-5" value="0" v-model="deleteOrCancelBid">Annullera</label></div>
      </div>
    </div>



    <div class="modal-buttons">
      <div class="grid2col">
        <button class="width-100 fg-black" @click="abort">
          avbryt
        </button>
        <button class="width-100" @click="save">
          spara
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'deleteBid',
  data() {
    return {
      // annulera = 0 , radera = 1
      deleteOrCancelBid: 0
    }
  },
  computed: {
    currentBid() {
      return this.$store.state.editBid;
    }
  },
  methods: {
    abort() {
      this.$root.modalOpen = false;
    },
    save() {
      let data = {
        id : this.$store.state.editBid.id,
        objectId: this.$route.params.id,
        remove: this.deleteOrCancelBid
      }

      this.$root.callFasAdApi("/internalapi/bid/delete", "DELETE", data)
      .then((data) => {
        this.$root.modalOpen = false;
        this.$store.dispatch('storeCurrentSelectedListing', { listingId: this.$route.params.id });
        this.$root.handleResponseMessage(data);
      })
      .catch(console.error);

    }
  }
}
</script>